import axios from 'axios'
import classNames from 'classnames'
import {VmButton, VmText} from 'components'
import {VmHeader} from 'molecules'
import QueryString from 'qs'
import React from 'react'
import {useEffect} from 'react'
import {useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {toCurrency} from 'utils/functions'
import moment from 'moment'
import QRCode from 'react-qr-code'

const {REACT_APP_BASE_URL_DOKTER: BASE_URL, REACT_APP_PPN_REGISTRASI: PPN_REGISTRASI} = process.env
const bank_code_map = {
  2: 'bca',
  3: 'mandiri',
  4: 'bri',
  5: 'bni',
  6: 'permata',
}

export default function BayarPerpanjangan() {
  const [dataRegistrasi, setDataRegistrasi] = useState({})
  const [dataRegistrasiDetail, setDataRegistrasiDetail] = useState({})
  const [dataVa, setDataVa] = useState(null)
  let [searchParams, setSearchParams] = useSearchParams()
  const [device, setDevice] = useState('')

  const navigate = useNavigate()
  const [uid, setUid] = useState(searchParams.get('dctid'))
  const [expiredLabel, setExpiredLabel] = useState('')

  const qrisBcaExpiredLabel = noreferensi => {
    const digits = String(noreferensi || '').replace(/\D/g, '')
    if (digits.length < 10) {
      return ''
    }
    const generatedAt = moment(digits.slice(-10), 'YYMMDDHHmm')
    if (!generatedAt.isValid()) {
      return ''
    }
    return generatedAt.add(60, 'minutes').format('DD MMMM YYYY HH:mm:ss')
  }

  useEffect(() => {
    axios
      .post(
        `${BASE_URL}/backend-data-registrasi/find-faktur-bayar`,
        QueryString.stringify({
          uid,
        })
      )
      .then(({data}) => {
        console.log('Data Registrasi: ', data)

        let registrasiDetail = data.detail
        setDataRegistrasi(data.data)
        setDataRegistrasiDetail(registrasiDetail)
        if (String(registrasiDetail?.regd_bayar) === '13') {
          setExpiredLabel(qrisBcaExpiredLabel(registrasiDetail?.regd_noreferensi))
        }

        const bayar = parseInt(registrasiDetail.regd_bayar, 10)
        if (bayar !== 12 && bayar !== 13) {
          axios
            .post(
              `${BASE_URL}/backend-data-registrasi/xendit-va`,
              QueryString.stringify({
                id: registrasiDetail.regd_idbayar,
              })
            )
            .then(({data: res}) => {
              setDataVa(res)
            })
            .catch(e => {
              console.log('Terjadi Kesalahan saat Get Detail Data Xendit')
            })
        }
      })

    detectDevice()
  }, [])

  useEffect(() => {
    if (String(dataRegistrasiDetail?.regd_bayar) !== '13' || !uid) {
      return
    }
    const poll = () => {
      axios
        .post(
          `${BASE_URL}/backend-data-registrasi/check-qris-bca`,
          QueryString.stringify({uid})
        )
        .then(({data: res}) => {
          if (!res || typeof res.status === 'undefined') {
            return
          }
          if (res.status == 3) {
            return
          }
          if (res.status == 1 || res.status == 2) {
            window.alert(res.message || (res.status == 1 ? 'Pembayaran berhasil' : 'QRIS expired'))
            if (window?.ReactNativeWebView?.postMessage) {
              window.ReactNativeWebView.postMessage('closeWebview:')
            } else {
              navigate(-1)
            }
          }
        })
        .catch(() => {})
    }
    poll()
    const timer = setInterval(poll, 30000)
    return () => clearInterval(timer)
  }, [dataRegistrasiDetail?.regd_bayar, uid])

  const detectDevice = () => {
    let isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )

    setDevice(isMobile ? 'mobile' : 'web')
    // this.setState({device: isMobile ? 'mobile' : 'web'}, this.getInitialData)
  }

  const total =
    parseFloat(dataRegistrasiDetail?.regd_harga_paket) -
    parseFloat(dataRegistrasiDetail?.regd_diskon_paket)
  const pajakRegistrasi = total * (parseFloat(PPN_REGISTRASI) / 100)
  let hargaFinal = (
    total + pajakRegistrasi
  ).toString()
  return (
    <>
      <div
        className="container px-4 pt-20 pb-24 !max-w-none"
      >
        <VmHeader
          HeaderName={'Menu'}
          HeaderType={'Pembayaran'}
          className="fixed py-4 z-10 top-0 left-4 right-4 bg-white"
          classNameTitle="!pl-4"
          HeaderMode={'bg-blue-gradient'}
          onBackPress={_ => {
            if (window?.ReactNativeWebView?.postMessage) {
              // Send message untuk menutup webview
              window.ReactNativeWebView.postMessage('closeWebview:')
            } else {
              // Jika dibuka lewat web, maka navigate back
              navigate(-1)
            }
          }}
          showBack={device == 'mobile'}
        />

        <div id="card" className="p-4 shadow-2xl rounded-xl">
          {[12,13].includes(parseInt(dataRegistrasiDetail?.regd_bayar)) ? (
            <>
              <Qris value={dataRegistrasiDetail?.regd_qrcode} device={device} />
              {String(dataRegistrasiDetail?.regd_bayar) === '13' && expiredLabel ? (
                <VmText className="text-center text-sm text-danger mb-2">
                  Bayar sebelum {expiredLabel} WIB
                </VmText>
              ) : null}
            </>
          ) : (
            <>
              <Va
                va_code={dataRegistrasiDetail?.regd_va_number}
                bank_code={bank_code_map[dataRegistrasiDetail?.regd_bayar]}
                nominal={toCurrency(hargaFinal)}
              />
              <VmText className="text-center text-sm text-danger mb-2">
                {(first => {
                  let txt
                  if (dataVa) {
                    txt = `Bayar sebelum ${moment(
                      dataVa.expiration_date
                    ).format('DD MMM YYYY HH:mm')} WIB`
                  } else {
                    txt = 'Sedang Memuat...'
                  }
                  return txt
                })()}
              </VmText>
            </>
          )}

          <VmText className="text-center text-sm text-primary">
            Setelah Anda melakukan pembayaran Anda bisa login ke aplikasi Vmedis
            dan masa aktif akan otomatis diperpanjang
          </VmText>

          {/* Jika mode web, maka tidak tampilkan tombol selesai */}
          {device == 'mobile' && (
            <VmButton
              onClick={() => {
                if (window?.ReactNativeWebView?.postMessage) {
                  // Send message untuk menutup webview
                  window.ReactNativeWebView.postMessage('closeWebview:')
                }
              }}
              style={{marginTop: 20}}
              full
              className={classNames('')}
            >
              {'Selesai'}
            </VmButton>
          )}
        </div>
      </div>
    </>
  )
}

const Va = ({va_code, bank_code, nominal}) => {
  let imgmap = {
    mandiri: 'https://register.vmedis.com/foto-bayar/mandiri.png',
    permata: 'https://register.vmedis.com/foto-bayar/permata.png',
    bni: 'https://register.vmedis.com/foto-bayar/bni.png',
    bri: 'https://register.vmedis.com/foto-bayar/bri.png',
    bca: 'https://register.vmedis.com/foto-bayar/bca.png',
  }
  return (
    <div>
      <img className="w-1/2 mx-auto mb-2" src={imgmap[bank_code]} />
      <p className="font-bold text-zinc-600 mb-2 text-sm">
        No. Virtual Account
      </p>
      <p className="text-zinc-600 mb-4 text-md">{va_code}</p>

      <p className="font-bold text-zinc-600 mb-2 text-sm">
        Nominal Yang Akan Dibayarkan
      </p>
      <p className="text-zinc-600 mb-4 text-md">Rp. {nominal}</p>
    </div>
  )
}

const Qris = ({value = '', device}) => {
  return (
    <div className="flex flex-col items-center mb-4">
      <img className="" src="https://register.vmedis.com/foto-bayar/qris.png" />
      <QRCode
        size={256}
        style={{
          height: 'auto',
          maxWidth: '100%',
          width: device == 'mobile' ? '100%' : '30%',
        }}
        value={value}
        viewBox={`0 0 256 256`}
      />
    </div>
  )
}
